import React from 'react';

interface StripeFallbackProps {
  onRetry?: () => void;
}

const StripeFallback: React.FC<StripeFallbackProps> = ({ onRetry }) => {
  return (
    <div className="stripe-fallback" style={{
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      border: '1px solid #e9ecef',
      borderRadius: '8px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#6c757d', marginBottom: '16px' }}>
        Payment System Temporarily Unavailable
      </h3>
      <p style={{ color: '#6c757d', marginBottom: '16px' }}>
        We're experiencing issues loading our secure payment system. This might be due to:
      </p>
      <ul style={{ textAlign: 'left', color: '#6c757d', marginBottom: '20px' }}>
        <li>Network connectivity issues</li>
        <li>Ad blocker blocking payment scripts</li>
        <li>Temporary service interruption</li>
      </ul>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        {onRetry && (
          <button 
            onClick={onRetry}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        )}
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Refresh Page
        </button>
      </div>
      <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '16px' }}>
        If the problem persists, please contact support or try again later.
      </p>
    </div>
  );
};

export default StripeFallback;
